import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createTaxRevenueTypes,
  getTaxRevenueTypesList,
  history,
  getSingleTaxRevenueTypes,
  creating,
}) {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    type: '',
    cumulative_amount: 0,
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    name: 'required',
    type: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      year_from: moment(_.get(formData, 'year_from')).format('YYYY'),
    };

    createTaxRevenueTypes(args, ({ data }) => {
      setModal({ isOpen: false });
      getTaxRevenueTypesList();
      history.push(`/bpls/settings/tax-revenue-types/${_.get(data, 'id')}`);
      getSingleTaxRevenueTypes(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description:
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Type: {validateForm.renderMessage('type')}
            </label>
            <Select
              options={c.TYPES}
              placeholder="Select Tax Revenue Type"
              onChange={handleDropDownChange('type')}
            />
          </div>
          {_.get(formData, 'type') === 'MULTIPLE' ? (
            <div className="col-12 form-group">
              <input
                name="cumulative_amount"
                type="checkbox"
                checked={_.get(formData, 'cumulative_amount')}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="full-label mb-0 ml-2">
                Cumulative Amount in View OR
              </label>
            </div>
          ) : (
            ''
          )}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getTaxRevenueTypesList: PropTypes.instanceOf(Function).isRequired,
  createTaxRevenueTypes: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleTaxRevenueTypes: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_TAX_REVENUE_TYPES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
